import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ProductionKeyPerformanceIndicatorEvaluation } from 'src/app/models/production-key-performance-indicator-evaluation.model';
import {
  ConfiguredApplicationsEvaluationData,
  ConfiguredApplicationStatusDetail,
} from 'src/app/models/configured-applications-kpi-data.model';

@Component({
  selector: 'app-configured-applications-details',
  imports: [MatIconModule],
  templateUrl: './configured-applications-details.component.html',
  styleUrl: './configured-applications-details.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfiguredApplicationsDetailsComponent {
  currentMonthEvaluation = input<ProductionKeyPerformanceIndicatorEvaluation | null>(null);

  private readonly detailsData = computed((): ConfiguredApplicationsEvaluationData | null => {
    const rawData = this.currentMonthEvaluation()?.data;
    return ConfiguredApplicationsDetailsComponent.isConfiguredApplicationsEvaluationData(rawData) ? rawData : null;
  });

  unconfiguredApplications = computed((): ConfiguredApplicationStatusDetailSerialized[] => {
    return (this.detailsData()?.unconfigured_applications_detail ?? []).map(
      (application): ConfiguredApplicationStatusDetailSerialized => ({
        ...application,
        reason_label: ConfiguredApplicationsDetailsComponent.buildUnconfiguredReasonLabel(application),
      })
    );
  });

  configuredCount = computed((): number => this.detailsData()?.configured_applications_count ?? 0);
  totalApplications = computed((): number => this.detailsData()?.total_applications ?? 0);

  public static isConfiguredApplicationsEvaluationData(data: unknown): data is ConfiguredApplicationsEvaluationData {
    if (typeof data !== 'object' || data === null) {
      return false;
    }

    const candidate = data as Partial<ConfiguredApplicationsEvaluationData>;

    return (
      typeof candidate.total_applications === 'number' &&
      typeof candidate.configured_applications_count === 'number' &&
      typeof candidate.unconfigured_applications_count === 'number'
    );
  }

  private static buildUnconfiguredReasonLabel(application: ConfiguredApplicationStatusDetail): string {
    const missing: string[] = [];

    if (application.has_token === false) {
      missing.push('sin GitHub App');
    }

    if (application.has_environment === false) {
      missing.push('sin environment');
    }

    if (missing.length === 0) {
      return 'No configurada';
    }

    return missing.join(' · ');
  }
}

interface ConfiguredApplicationStatusDetailSerialized extends ConfiguredApplicationStatusDetail {
  reason_label: string;
}
